module.exports = __webpack_public_path__ + "img/justine_wichmann_10.4bc5dacf.jpg";